import Navigation from './Navigation';
import { GuidedTour } from './GuidedTour';
import { CookieConsent } from './CookieConsent';
import { APP_VERSION } from '../version';

export const AppLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen" data-testid="app-layout">
      <Navigation />
      <GuidedTour />
      {/* Main content with padding for desktop sidebar */}
      <main className="flex-1 main-content-mobile md:pt-16">
        {children}
      </main>
      <footer
        className="hidden md:block border-t py-3 px-4 text-center"
        style={{ borderColor: 'var(--neutral-200)', backgroundColor: 'var(--bg-primary)' }}
        data-testid="app-version-footer"
      >
        <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
          &copy; {new Date().getFullYear()} <span className="font-semibold" style={{ color: 'var(--primary-400)' }}>Nannyou</span> &middot; {APP_VERSION}
        </p>
      </footer>
      <CookieConsent />
    </div>
  );
};
